import React from 'react';
import PropTypes from 'prop-types';
import { provideContext } from '../../../../context/context.jsx';
import './returnInstructionsModal.scss';
import { Trans } from 'react-i18next';

const ReturnInstructionsModal = ({ t, onCloseModal, modalRef, isRetailSNOO }) => (
  <div ref={modalRef} className="ReturnInstructionsModal" onClick={onCloseModal}>
    <div className="modal-center" onClick={e => e.stopPropagation()}>
      <div className="inner-modal-center">
        <div className="header-wrapper">
          <h3>{t('return_instructions_modal_title', 'Return Instructions')}</h3>
          <span className="close-modal" onClick={onCloseModal}>X</span>
        </div>
        <div className="modal-text">
          <ul>
            {!isRetailSNOO && (
              <li>
                <Trans i18nKey="return_instructions_clean">
                  Clean excessive dirt, debris, spit up, and other stains from SNOO before returning to avoid deductions from your security deposit refund. Follow the cleaning instructions in{' '}
                  <a href="https://www.happiestbaby.com/blogs/snoo/how-to-clean-snoo" target="_blank" rel="noopener noreferrer">
                    this blog and video.
                  </a>{' '}
                </Trans>
              </li>
            )}

            <li>
              <Trans i18nKey="return_instructions_pack">
                Carefully pack SNOO in the original packaging and box following this helpful {' '}
                <a href="https://happiestbaby.zendesk.com/hc/en-us/articles/360015142814" target="_blank" rel="noopener noreferrer">
                  video
                </a>{' '}
                (do not include the SNOO Sacks, sheet, mattress, and printed materials—they're yours to keep).
              </Trans>
            </li>
            <li>
              {t('return_instructions_label', 'Download and print the shipping label. Please remove the old shipping label before attaching the new shipping label.')}
            </li>
            <li>
              {t('return_instructions_ship', 'Attach the label to the box and schedule a UPS pickup or drop it off at your nearest UPS location. Please note that it takes about an hour after your label is generated to schedule a pickup using the button below. (If the return is not postmarked within 10 days of receiving the shipping label, the return will be cancelled, after which a new return must be initiated.)')}
            </li>
          </ul>
          <div className="return-instructions-note">
            <span style={{ margin: '0 auto' }}>
              {t('return_instructions_note', 'Note: SNOO is heavy and can be damaged if NOT returned in the original box + packaging. If your SNOO is damaged during the return you will be held responsible.')}
            </span>
          </div>
        </div>
        <div className="button-wrap">
          <button className="close-btn" onClick={onCloseModal}>{t('button_text_close', 'Close')}</button>
        </div>
      </div>
    </div>
  </div>
);

ReturnInstructionsModal.propTypes = {
  t: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  modalRef: PropTypes.object,
  isRetailSNOO: PropTypes.bool,
};

export default provideContext(ReturnInstructionsModal); 